import request from '@/utils/request'
let resquest = process.env.VUE_APP_BASE_API

export default {
  /* ---------------------------------常见问题---------------------------- */

  //查询常见问题列表
  contactUsList() {
    return request({
      url: `${resquest}/novel/public/problem`,
      method: 'get'
    })
  },
  //举报建议-意见反馈
  feedback(data) {
    return request({
      url: `${resquest}/novel/app/feedback`,
      method: 'post',
      data
    })
  },
}